export const GET_MEMES = "GET_MEMES";
export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const LAUGH = "LAUGH";